import { takeEvery, put } from "redux-saga/effects";
import * as actionTypes from "../constants/actionTypes";
import * as actions from "../actions";
import axios from "../services";
import { sessionExpiredMsg } from "../constants/constants";

function* getUserContestProfileData(action) {
  try {
    let Data = action.payload;
    let user = JSON.parse(localStorage.getItem("userData"));
    if (Data.userID == null) Data.userID = user._id;
    let response = yield axios
      .get(`/users/contest/${Data.ID}?userId=${Data.userID}`)
      .then(async response => response)
      .catch(async error => {
        return error;
      });
    if (response == "Error: Request failed with status code 401") {
      yield put(actions.hideAppLoader());
      yield put(
        actions.modalOpen({
          message: sessionExpiredMsg,
          redirectURL: `/logout`
        })
      );
    } else if (response.status !== 200) {
      yield put(actions.hideAppLoader());
      yield put(actions.modalOpen({ message: response.message }));
      yield put(actions.modalOpen({ message: response.data.msg }));
    }

    let mediaResponse = yield axios
      .get(`/users/contest/${Data.ID}/get-all-media1/${Data.userID}?limit=20`)
      .then(async response => response)
      .catch(async error => {
        return error;
      });

    let votingStats = yield axios
      .get(`/votes/votes-statistics/${Data.ID}?skip=0&limit=9`)
      .then(async response => response)
      .catch(async error => {
        return error;
      });

    let hostEvalutedData = yield axios
      .get(`/users/contest/${Data.ID}/host-evaluated-videos?skip=0&limit=9`)
      .then(async response => response)
      .catch(async error => {
        return error;
      });

    if (hostEvalutedData.status == 200 && votingStats.status == 200) {
    } else if (hostEvalutedData.status !== 200) {
      yield put(actions.hideAppLoader());
      yield put(
        actions.modalOpen({ message: hostEvalutedData.response.data.msg })
      );
    } else if (votingStats.status !== 200) {
      yield put(actions.hideAppLoader());
      yield put(actions.modalOpen({ message: votingStats.response.data.msg }));
    }

    if (mediaResponse == "Error: Request failed with status code 401") {
      yield put(actions.hideAppLoader());
      yield put(
        actions.modalOpen({
          message: sessionExpiredMsg,
          redirectURL: `/logout`
        })
      );
    } else if (mediaResponse.status !== 200) {
      yield put(actions.hideAppLoader());
      yield put(
        actions.modalOpen({ message: mediaResponse.response.data.msg })
      );
    } else {
      let Media = mediaResponse.data.data.medias;
      for (let index = 0; index < Media.length; index++) {
        if (Media[index].mediaType != "image") {
          let status = yield axios
            .get(
              `https://cdn.jwplayer.com/v2/media/${Media[index].url}/poster.jpg?width=480`
            )
            .then(async response => response)
            .catch(async error => {
              return error;
            });
          Media[index].imageStatus = status.status == 200;
        }
      }
      yield put(
        actions.getUserContestProfileDataSuccess({
          contestData: response.data.data,
          contestMedia: Media,
          votingStats: votingStats.data.data,
          hostEvalutedData: hostEvalutedData.data.data
        })
      );
    }
  } catch (error) {
    console.log("ERROR FROM SAGA FEATURED VIDEO", error.message);
  }
}

function* getUserContestProfileMedia(action) {
  try {
    let Data = action.payload;
    let user = JSON.parse(localStorage.getItem("userData"));
    if (Data.userID == null) Data.userID = user._id;
    let mediaResponse = yield axios
      .get(
        `/users/contest/${Data.ID}/get-all-media1/${Data.userID}?skip=${Data.contestMediaLength}&limit=20`
      )
      .then(async response => response)
      .catch(async error => {
        return error;
      });

    if (mediaResponse == "Error: Request failed with status code 401") {
      yield put(actions.hideAppLoader());
      yield put(
        actions.modalOpen({
          message: sessionExpiredMsg,
          redirectURL: `/logout`
        })
      );
    } else if (mediaResponse.status !== 200) {
      yield put(actions.hideAppLoader());
      yield put(actions.modalOpen({ message: response.message }));
      yield put(
        actions.modalOpen({ message: mediaResponse.response.data.msg })
      );
    } else {
      let Media = mediaResponse.data.data.medias;
      for (let index = 0; index < Media.length; index++) {
        if (Media[index].mediaType != "image") {
          let status = yield axios
            .get(
              `https://cdn.jwplayer.com/v2/media/${Media[index].url}/poster.jpg?width=480`
            )
            .then(async response => response)
            .catch(async error => {
              return error;
            });
          Media[index].imageStatus = status.status == 200;
        }
      }
      yield put(actions.getUserContestProfileMediaSuccess(Media));
    }
  } catch (error) {
    yield put(actions.hideAppLoader());
    console.log("ERROR FROM SAGA FEATURED VIDEO", error.message);
  }
}

function* contestPost(action) {
  let response = yield axios
    .post(`/users/contest/111/media`, action.payload)
    .then(async response => response)
    .catch(async error => {
      return error;
    });

  if (response.status == 200) {
    yield put(
      actions.modalOpen({
        message: response.data.msg,
        notifyType: 2,
        redirectURL: `/contest-profile/${encodeURIComponent(
          action.payload.arrContestName[0]
        )}`
      })
    );
    yield put(actions.hideAppLoader());
  } else if (response == "Error: Request failed with status code 401") {
    yield put(actions.hideAppLoader());
    yield put(actions.modalOpen({ message: response.message }));
    yield put(
      actions.modalOpen({ message: sessionExpiredMsg, redirectURL: `/logout` })
    );
  } else {
    yield put(actions.hideAppLoader());
    yield put(actions.modalOpen({ message: response.response.data.msg }));
  }
}

function* likeingOrBookmarkContest(action) {
  try {
    let {
      id,
      contestName,
      interactionType,
      from,
      index,
      mediaIndex,
      e
    } = action.payload;
    let params = {
      by: JSON.parse(localStorage.getItem("userData"))._id,
      interactionType: interactionType,
      mediaId: id.toString()
    };

    let response = yield axios
      .post(
        `users/contest/${encodeURIComponent(contestName)}/media/${id}`,
        params
      )
      .then(async response => response)
      .catch(async error => {
        return error;
      });

    if (response.status == 200) {
      const data = {
        index: index,
        interactionType: interactionType,
        from: from,
        mediaIndex: mediaIndex
      };
      if (from == "contestProfile") {
        e.innerHTML = Number(e.innerHTML) + 1;
        // yield put(actions.getUserContestProfileData({ ID: action.payload.ID, userID: action.payload.userID }))
      } else if (from == "explore") {
        yield put(actions.sendContestLikeFeedBackSuccess(data));
      } else if (from == "savedPosts") {
        yield put(actions.getSavedPostData());
      } else if (from == "featureVideo") {
        yield put(actions.sendContestFeaturedvideoLikeFeedBackSuccess(data));
      } else if (from == "contestDetails") {
        yield put(actions.sendContestContestDetailLikeFeedBackSuccess(data));
      } else if (from == "singleMediaDetail") {
        yield put(actions.sendMediaLikeFeedBackSuccess(data));
      }
    } else if (response == "Error: Request failed with status code 401") {
      yield put(actions.hideAppLoader());
      yield put(
        actions.modalOpen({
          message: sessionExpiredMsg,
          redirectURL: `/logout`
        })
      );
    } else if (response.status !== 200) {
      yield put(actions.hideAppLoader());
      yield put(actions.modalOpen({ message: response.message }));
      yield put(actions.modalOpen({ message: response.response.data.msg }));
    } else {
      if (e.target.innerHTML == "Like") {
        e.target.innerHTML = "Unlike";
      } else if (e.target.innerHTML == "Unike") {
        e.target.innerHTML = "Like";
      } else if (e.target.innerHTML == "Remove from bookmark") {
        e.target.innerHTML = "Save in bookmark";
      } else {
        e.target.innerHTML = "Remove from bookmark";
      }
    }
    // yield localStorage.removeItem('onContestProfileLikeContest');
    // yield localStorage.removeItem('onContestProfileBookmarkContest');
    action.payload.editFlag();
  } catch (error) {
    yield put(actions.hideAppLoader());
    if (error.data != undefined && error.data.isVerify == false) {
    } else {
    }
  }
}

function* removeLikeOrBookmarkFeedback(action) {
  try {
    let { id, interactionType, from, index, mediaIndex, e } = action.payload;
    let response = yield axios
      .delete(
        `users/contest/media-remove-like-bookmark/${id}/${interactionType}`
      )
      .then(async response => response)
      .catch(async error => {
        return error;
      });

    if (response.status == 200) {
      const data = {
        index: index,
        mediaIndex: mediaIndex,
        interactionType: interactionType,
        from: from
      };
      if (from == "contestProfile") {
        e.innerHTML = Number(e.innerHTML) == 0 ? 0 : Number(e.innerHTML) - 1;
        // yield put(actions.getUserContestProfileData({ ID: action.payload.ID, userID: action.payload.userID }))
      } else if (from == "savedPosts") {
        yield put(actions.getSavedPostData());
      } else if (from == "explore") {
        yield put(actions.sendContestLikeFeedBackSuccess(data));
      } else if (from == "featureVideo") {
        yield put(actions.sendContestFeaturedvideoLikeFeedBackSuccess(data));
      } else if (from == "contestDetails") {
        yield put(actions.sendContestContestDetailLikeFeedBackSuccess(data));
      } else if (from == "singleMediaDetail") {
        yield put(actions.sendMediaLikeFeedBackSuccess(data));
      }
    } else if (response == "Error: Request failed with status code 401") {
      yield put(actions.hideAppLoader());
      yield put(
        actions.modalOpen({
          message: sessionExpiredMsg,
          redirectURL: `/logout`
        })
      );
    } else if (response.status !== 200) {
      yield put(actions.hideAppLoader());
      yield put(actions.modalOpen({ message: response.message }));
      yield put(actions.modalOpen({ message: response.response.data.msg }));
    } else {
      if (e.target.innerHTML == "Like") {
        e.target.innerHTML = "Unlike";
      } else if (e.target.innerHTML == "Unike") {
        e.target.innerHTML = "Like";
      } else if (e.target.innerHTML == "Remove from bookmark") {
        e.target.innerHTML = "Save in bookmark";
      } else {
        e.target.innerHTML = "Remove from bookmark";
      }
    }
    yield localStorage.removeItem("onContestProfileLikeContest");
    yield localStorage.removeItem("onContestProfileBookmarkContest");
    action.payload.editFlag();
  } catch (error) {
    yield put(actions.hideAppLoader());
    //yield put(actions.modalOpen({ message: response.response.data.msg }));
    if (error.data != undefined && error.data.isVerify == false) {
    } else {
    }
  }
}

function* sendContestMediaReport(action) {
  try {
    let { id, from } = action.payload;
    let params = {
      mediaUserId: JSON.parse(localStorage.getItem("userData"))._id,
      mediaId: id.toString(),
      reasonId: ""
    };
    console.log("PING SANCHIT IF YOU SEE THIS", params);

    // let response = yield axios.post(`/users/contest/media/report/`, params)
    // .then(async response => response)
    // .catch(async error => {
    //     //console.log(error);
    //     // await put(actions.hideAppLoader());
    //     // await put(actions.modalOpen({ message: error.response.data.msg }));
    // });
    // if (response.status == 200) {
    // yield put(actions.getExploreData());

    //     if (from == 'contestProfile') {
    //         yield put(actions.getUserContestProfileData({ ID: action.payload.ID, userID: action.payload.userID }))
    //     } else if (from == 'savedPosts') {
    //         yield put(actions.getSavedPostData())
    //     }
    //     //console.log('SUCCESS');
    //     // yield put(actions.modalOpen({ message: response.data.msg, notifyType: 2, redirectURL: `/contest-profile?id:${encodeURIComponent(action.payload.arrContestName[0])}` }));
    //     // yield put(actions.modalOpen({ message: response.data.msg, notifyType: 2, redirectURL: `/contest-profile/${encodeURIComponent(action.payload.arrContestName[0])}` }));
    //     // yield put(actions.hideAppLoader());
    // }
  } catch (error) {
    if (error.data != undefined && error.data.isVerify == false) {
    } else {
    }
  }
}
function* sendContestMeidaDelete(action) {
  try {
    let {
      contestName,
      mediaId,
      mediaStatus,
      index,
      mediaIndex,
      from
    } = action.payload;
    let response = yield axios
      .delete(
        `/users/delete-media?contestName=${contestName}&mediaId=${mediaId}&mediaStatus=deleted`
      )
      .then(async response => response)
      .catch(async error => {
        return error;
      });

    if (response.status == 200) {
      const data = {
        index: index,
        mediaIndex: mediaIndex,
        interactionType: "D",
        from: from
      };
      if (from == "contestProfile") {
        yield put(
          actions.getUserContestProfileData({
            ID: action.payload.ID,
            userID: action.payload.userID
          })
        );
      } else if (from == "savedPosts") {
        yield put(actions.getSavedPostData());
      } else if (from == "explore") {
        yield put(actions.sendContestLikeFeedBackSuccess(data));
      } else if (from == "featureVideo") {
        yield put(actions.sendContestFeaturedvideoLikeFeedBackSuccess(data));
      } else if (from == "contestDetails") {
        yield put(actions.sendContestContestDetailLikeFeedBackSuccess(data));
      }
      yield put(actions.hideAppLoader());
    } else if (response == "Error: Request failed with status code 401") {
      yield put(actions.hideAppLoader());
      yield put(
        actions.modalOpen({
          message: sessionExpiredMsg,
          redirectURL: `/logout`
        })
      );
    } else {
      yield put(actions.hideAppLoader());
      yield put(actions.modalOpen({ message: response.response.data.msg }));
    }
  } catch (error) {
    yield put(actions.hideAppLoader());
    if (error.data != undefined && error.data.isVerify == false) {
    } else {
    }
  }
}
function* getReportModalReason(action) {
  try {
    let response = yield axios
      .get(`/reason?reasonType=report`)
      .then(async response => response)
      .catch(async error => {
        return error;
      });

    if (response.status == 200) {
      yield put(actions.getReportModalReasonDataSuccess(response.data.data));
    } else if (response == "Error: Request failed with status code 401") {
      yield put(actions.hideAppLoader());
      yield put(
        actions.modalOpen({
          message: sessionExpiredMsg,
          redirectURL: `/logout`
        })
      );
    } else {
      yield put(actions.hideAppLoader());
      yield put(actions.modalOpen({ message: response.message }));
      yield put(actions.modalOpen({ message: response.response.data.msg }));
    }
  } catch (error) {
    yield put(actions.hideAppLoader());
    if (error.data != undefined && error.data.isVerify == false) {
    } else {
    }
  }
}
function* postReport(action) {
  try {
    let response = yield axios
      .post(`/users/contest/media/report`, action.payload)
      .then(async response => response)
      .catch(async error => {
        return error;
      });

    if (response.status == 200) {
      yield put(actions.reportModalClose());
      yield put(actions.postReportSuccess());
    } else if (response == "Error: Request failed with status code 401") {
      yield put(actions.hideAppLoader());
      yield put(
        actions.modalOpen({
          message: sessionExpiredMsg,
          redirectURL: `/logout`
        })
      );
    } else {
      yield put(actions.hideAppLoader());
      yield put(actions.modalOpen({ message: response.message }));
      yield put(actions.modalOpen({ message: response.response.data.msg }));
    }
  } catch (error) {
    yield put(actions.hideAppLoader());
    if (error.data != undefined && error.data.isVerify == false) {
    } else {
    }
  }
}
function* updateProfileMedia(action) {
  try {
    let response = yield axios
      .post(`/users/contest/update-talent-profile`, action.payload)
      .then(async response => response)
      .catch(async error => {
        return error;
      });

    if (response.status == 200) {
      let user = JSON.parse(localStorage.getItem("userData"));
      let responseData = yield axios
        .get(`/users/contest/${action.payload.contestName}?userId=${user._id}`)
        .then(async response => response)
        .catch(async error => {
          return error;
        });

      if (responseData == "Error: Request failed with status code 401") {
        yield put(actions.hideAppLoader());
        yield put(
          actions.modalOpen({
            message: sessionExpiredMsg,
            redirectURL: `/logout`
          })
        );
        yield put(actions.hideUploadMediaLoader());
      } else if (responseData.status == 200) {
        yield put(actions.hideAppLoader());
        yield put(actions.hideUploadMediaLoader());
        yield put(actions.updateProfileMediaSuccess(responseData.data.data));
        yield put(
          actions.modalOpen({ message: response.data.msg, notifyType: 2 })
        );
      } else {
        yield put(actions.hideAppLoader());
        yield put(actions.modalOpen({ message: response.message }));
        yield put(
          actions.modalOpen({ message: responseData.response.data.msg })
        );
      }
    } else if (response == "Error: Request failed with status code 401") {
      yield put(actions.hideAppLoader());
      yield put(
        actions.modalOpen({
          message: sessionExpiredMsg,
          redirectURL: `/logout`
        })
      );
      yield put(actions.hideUploadMediaLoader());
    } else {
      yield put(actions.hideAppLoader());
      yield put(actions.modalOpen({ message: response.response.data.msg }));
    }
  } catch (error) {
    yield put(actions.hideAppLoader());
    yield put(actions.hideUploadMediaLoader());
    if (error.data != undefined && error.data.isVerify == false) {
    } else {
    }
  }
}
export default function* rootsaga() {
  yield takeEvery(
    actionTypes.GET_USER_CONTEST_PROFILE_DATA,
    getUserContestProfileData
  );
  yield takeEvery(
    actionTypes.GET_USER_CONTEST_PROFILE_MEDIA,
    getUserContestProfileMedia
  );
  yield takeEvery(actionTypes.CONTEST_POST, contestPost);
  yield takeEvery(
    actionTypes.SEND_CONTEST_LIKE_FEEDBACK,
    likeingOrBookmarkContest
  );
  yield takeEvery(
    actionTypes.REMOVE_CONTEST_LIKE_FEEDBACK,
    removeLikeOrBookmarkFeedback
  );
  yield takeEvery(
    actionTypes.SEND_CONTEST_MEDIA_REPORT,
    sendContestMediaReport
  );
  yield takeEvery(
    actionTypes.SEND_CONTEST_MEDIA_DELETE,
    sendContestMeidaDelete
  );
  yield takeEvery(
    actionTypes.GET_REPORT_MODAL_REASON_DATA,
    getReportModalReason
  );
  yield takeEvery(actionTypes.POST_REPORT, postReport);
  yield takeEvery(actionTypes.UPDATE_PROFILE_MEDIA, updateProfileMedia);
}
